import { gql } from 'graphql-request';
import { DateTime } from 'luxon';

export const PHOTO_AND_NOTES_COUNTS_QUERY = gql`
  query PhotoAndNotesCounts(
    $ranges: [DashboardRangeInput!]!
    $memberId: Uuid
    $projectId: Uuid
    $requirePermission: Boolean!
    $includeFooter: Boolean!
  ) {
    dashboard {
      photoAndNotesCounts(
        ranges: $ranges
        memberId: $memberId
        projectId: $projectId
        requirePermission: $requirePermission
        includeFooter: $includeFooter
      ) {
        countsByRange {
          startTime
          endTime
          count
        }
        photoCount
        noteCount
      }
    }
  }
`;

export interface IPhotoAndNotesRangeCount {
  startTime: string;
  endTime: string;
  count: number;
}

export interface IPhotoAndNotesCounts {
  countsByRange: IPhotoAndNotesRangeCount[];
  photoCount: number;
  noteCount: number;
}

// Shift a range boundary into the stored (UTC) `createdOn` space so the server buckets with a plain
// timestamp compare. This is the same `.minus(offset)` transform the card's createdOn filter used,
// just sent offset-free; applying it per bar reproduces the old client-side keep-UTC bucketing.
export function toCreatedOnBound(dateTime: DateTime): string {
  return dateTime
    .minus(dateTime.toLocal().offset * 60 * 1000)
    .toISO({ suppressMilliseconds: true, includeOffset: false })!;
}
